import React from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Link } from 'react-router';
import _ from 'lodash';
import * as moment from 'moment';

import { UserPerms } from 'store/configureStore';

import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import ArrowForward from 'material-ui/svg-icons/navigation/arrow-forward';

import MainInfo from './Sidebar/Size/MainInfo';

import AnnotationsEditor from './Content/AnnotationsEditor';
import AnnotationsList from './Content/AnnotationsList';
import ArchiveLetter from '../ArchiveLetter';
import HtmlContent from '../HtmlContent';
import SizesTable from './Sidebar/Size/SizesTable';

import TextEditor from './Content/TextEditor';

import { execute } from 'store/configureStore';
import { getLetter } from 'sagas/letters';
import * as sagaAnnotations from 'sagas/annotations';
import * as sagaLetters from 'sagas/lettersNew';

import { removeLetter } from 'actions/letters';
import { postAnnotations, removeAnnotations } from 'actions/annotations';
import { addVesselSize, removeLastVesselSize, getVesselSizes } from 'actions/vessels/size';
import { postRequestVessel } from 'actions/vessels/request';
import { removeGazetters, postGazetters } from 'actions/gazetters';
import { addNotification } from 'actions/notifications/notifications';
import { updateVessel } from 'actions/vessels/vessels';
import { getVessel } from 'services/vessels/vessels';

import styles from 'styles';

import * as actionTypes from 'constants/ActionTypes';

import ErrorBoundary from './ErrorBoundary';
import Attachments from '../Attachments';

class LetterVessel extends React.Component {
    constructor(props) {
        super(props);

        if (localStorage.getItem(`settings-size-vessel${props.objUser.user._id}`)) {
            this.initialState = JSON.parse(localStorage.getItem(`settings-size-vessel${props.objUser.user._id}`));
        } else {
            this.initialState = { annotationsServer: 'mailparse.net', clarifiedServer: 'standart' };
            localStorage.setItem(`settings-size-vessel${props.objUser.user._id}`, JSON.stringify(this.initialState));
        }

        this.state = {
            ...this.initialState,
            textLetter: '',
            currentVesselSizeIndex: 0,
            typeAnnotations: 'annotate',
            gazetters: [],
            filteredGazetters: [],
            annotations: [],
            openedAttachmentsDialog: false,

            selectedType: '',
            selectedServer: 'mailparse.net',
            tabValue: 0,
            errors: [],
        };

        this.addSizeTable = this.addSizeTable.bind(this);
        this.removeSizeTable = this.removeSizeTable.bind(this);
        this.changeAnnotationsServer = this.changeAnnotationsServer.bind(this);
        this.changeClarifiedServer = this.changeClarifiedServer.bind(this);
        this.clearSizeTable = this.clearSizeTable.bind(this);
        this.loadVesselData = this.loadVesselData.bind(this);
        this.handleArrowBack = this.handleArrowBack.bind(this);
        this.handleArrowForward = this.handleArrowForward.bind(this);
        this.updatePostGazetters = this.updatePostGazetters.bind(this);
        this.getLetterData = this.getLetterData.bind(this);

        this.handleTabChange = this.handleTabChange.bind(this);
    }

    async getLetterData(textEdit) {
        try {
            const { data: letter } = await execute(getLetter, this.props.routeParams.id, 'vessel');
            letter.gazettersArr = [];
            letter.type = 'vessel';
            // necessary for distinguishing vessel order and vessel sizes in letters.js
            letter.fromVesselSizes = true;
            if (textEdit) {
                letter.text = textEdit;
            }
            
            const annotationsResponse = await execute(
                sagaAnnotations.postAnnotations, 
                letter.text, 
                letter.type, 
                this.state.annotationsServer, 
                { 
                    emailId: letter._id,
                    subject: letter.subject,
                    date: moment(letter.date).format('DD-MM-YYYY'),
                },
            );
            if (annotationsResponse) {
                letter.gazettersArr = annotationsResponse.data.annotations;
                if (annotationsResponse.data.newclarified) {
                    letter.newclarified = annotationsResponse.data.newclarified;
                }
            }

            await execute(sagaLetters.updateLetter, _.omit(letter, 'gazettersArr'), 'vessel', this.state.clarifiedServer);
        } catch (error) {
            addNotification({
                type: actionTypes.ADD_NOTIFICATION,
                notification: {
                    title: 'Error',
                    message: error.errors ? error.errors.messages[0] : error,
                    level: 'error',
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 10,
                },
            });
        }
    }

    changeAnnotationsServer(e, i, value) {
        this.initialState = {
            annotationsServer: value,
            clarifiedServer: this.state.clarifiedServer,
        };

        localStorage.setItem(`settings-size-vessel${this.props.objUser.user._id}`, JSON.stringify(this.initialState));

        this.setState(this.initialState, () => { this.getLetterData(); });
    }

    changeClarifiedServer(e, i, value) {
        this.initialState = {
            annotationsServer: this.state.annotationsServer,
            clarifiedServer: value,
        };

        localStorage.setItem(`settings-size-vessel${this.props.objUser.user._id}`, JSON.stringify(this.initialState));

        this.setState(this.initialState, () => { this.getLetterData(); });
    }

    loadVesselData(id) {
        if (id) {
            getVessel(id)
                .then((response) => {
                // not using inputs for files -> delete image array
                    if (response.data) {
                        delete response.data.images;
                    }
                    this.setState(response.data);
                });
        }
    }

    UNSAFE_componentWillMount() {
        this.getLetterData();
    }

    changeServer(e, i, value) {
        this.setState({
            selectedServer: value,
        }, () => {
            this.getLetterData();
        });
    }

    createTerms(vesselSizes) {
        vesselSizes.forEach((vesselSize) => {
            const terms = _.cloneDeep(vesselSize.terms);

            terms.forEach((term) => {
                if (term.type) {
                    term.value = `${term.type} ${term.value}`;
                }
            });

            vesselSize.terms = terms;
        });
    }
    
    removeSizeTable() {
        const { currentVesselSizeIndex } = this.state;
        const { vesselSizes } = this.props;
        this.props.removeLastVesselSize();
        if (!(currentVesselSizeIndex === 0)) {
            this.setState({
                currentVesselSizeIndex: currentVesselSizeIndex - 1,
            });
        } else if (currentVesselSizeIndex === 0 && vesselSizes.length > 1) {
            this.setState({
                currentVesselSizeIndex: 0,
            });
        }
    }

    clearSizeTable() {
        this.props.removeLastVesselSize();
        this.props.addVesselSize();
    }

    addSizeTable() {
        const { vesselSizes } = this.props;
        this.props.addVesselSize();
        if (vesselSizes.length === 0) {
            this.setState({
                currentVesselSizeIndex: 0,
            });
        } else {
            this.setState({
                currentVesselSizeIndex: vesselSizes.length,
            });
        }
    }

    componentWillUnmount() {
        this.props.removeGazetters();
        this.props.removeAnnotations();
        this.props.removeLetter();
    }

    handleArrowBack(e) {
        e.preventDefault();
        const { vesselSizes } = this.props;
        const { currentVesselSizeIndex } = this.state;
        if (vesselSizes.length > 1) {
            this.setState({
                currentVesselSizeIndex: (currentVesselSizeIndex - 1) < 0 ? vesselSizes.length - 1 : currentVesselSizeIndex - 1, 
            });
        }
        if (vesselSizes[currentVesselSizeIndex].vessel) {
            this.loadVesselData(vesselSizes[currentVesselSizeIndex].vessel);
        }
    }

    handleArrowForward(e) {
        e.preventDefault();
        const { vesselSizes } = this.props;
        const { currentVesselSizeIndex } = this.state;
        if (vesselSizes.length > 1) {
            this.setState({
                currentVesselSizeIndex: (currentVesselSizeIndex + 1) === vesselSizes.length ? 0 : currentVesselSizeIndex + 1, 
            });
        }
        if (vesselSizes[currentVesselSizeIndex].vessel) {
            this.loadVesselData(vesselSizes[currentVesselSizeIndex].vessel);
        }
    }

    updatePostGazetters(textLetter = this.state.textLetter) {
        this.setState({
            textLetter,
            gazetters: [],
            filteredGazetters: [],
            annotations: [],
        }, () => {
            this.props.postGazetters(
                textLetter,
                {
                    emailId: this.props.letter._id,
                    subject: this.props.letter.subject,
                    date: moment(this.props.letter.date).format('DD-MM-YYYY'),
                },
            );
        });
    }

    handleTabChange(tabValue) {
        this.setState({
            tabValue,
        });
        if (this.props.vesselSizes[tabValue] && this.props.vesselSizes[tabValue].vessel) {
            this.loadVesselData(this.props.vesselSizes[tabValue].vessel);
        }
    }

    toggleAttachmentsDialog = () => {
        this.setState({
            openedAttachmentsDialog: !this.state.openedAttachmentsDialog,
        });
    }

    render() {
        const {
            annotationsServer, clarifiedServer, currentVesselSizeIndex, textLetter, openedAttachmentsDialog, 
        } = this.state;
        const {
            routeParams, letter, router, vesselSizes, 
        } = this.props;
        return (
            <div id='single-letter-cargo' className='single-letter'>
                <div className='content' style={{ width: '53vw' }}>
                    <div className='management'>
                        <div className='management-children'>
                            <RaisedButton
                                label='Gazetteer'
                                containerElement={<Link to={`/${routeParams.id}`} />}
                                primary
                                className="btn"
                                labelStyle={{ fontSize: '10px' }}
                                style={{ height: '25px', margin: '10px 5px 10px 0' }}
                                buttonStyle={{ height: '25px', lineHeight: '25px', minWidth: '60px' }}
                            />
                            <ErrorBoundary>
                                <ArchiveLetter router={router} />
                            </ErrorBoundary>

                            <ErrorBoundary>
                                <HtmlContent
                                    letter={letter}
                                />
                            </ErrorBoundary>
                            <Attachments 
                                openedAttachmentsDialog={openedAttachmentsDialog}
                                toggleAttachmentsDialog={this.toggleAttachmentsDialog}
                                labelStyle={{ fontSize: '10px' }}
                                style={{ height: '25px', margin: '10px 0 10px 0' }}
                                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                className='btn'
                                attachments={letter.attachments}
                            />
                            <ErrorBoundary>
                                <TextEditor 
                                    textLetter={letter.text}
                                    getLetterData={this.getLetterData}
                                    updatePostGazetters={this.updatePostGazetters}
                                    removeGazetters={this.props.removeGazetters}
                                    removeAnnotations={this.props.removeAnnotations}
                                />
                            </ErrorBoundary>
                            
                            <ErrorBoundary>
                                <div className='btn'>
                                    <RaisedButton
                                        label='Order'
                                        containerElement={<Link to={`/${routeParams.id}/annotator/vessel`} />}
                                        labelStyle={{ fontSize: '10px' }}
                                        style={{ height: '25px', marginLeft: '-10px', minWidth: '50px' }}
                                        buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                        primary
                                    />
                                </div>
                            </ErrorBoundary>
                            {
                                UserPerms.isAdmin() ?
                                    <React.Fragment>
                                        <SelectField
                                            floatingLabelText='Annotations server'
                                            className='btn'
                                            value={annotationsServer}
                                            onChange={this.changeAnnotationsServer}
                                            style={{ width: '155px' }}
                                            selected
                                        >
                                            <MenuItem value='mailparse.net' primaryText='mailparse.net' />
                                            <MenuItem value='s4.anotatr.com' primaryText='s4.anotatr.com' />
                                            <MenuItem value='nata.im' primaryText='nata.im' />
                                            <MenuItem value='polza' primaryText='polza' />
                                            <MenuItem value='localhost' primaryText='localhost' />
                                        </SelectField>

                                        <SelectField
                                            floatingLabelText='Clarified server'
                                            className='btn'
                                            value={clarifiedServer}
                                            onChange={this.changeClarifiedServer}
                                            style={{ width: '110px' }}
                                            selected
                                        >
                                            <MenuItem value='standart' primaryText='api' />
                                            <MenuItem value='localhost:7775' primaryText='localhost' />
                                        </SelectField>
                                    </React.Fragment>
                                    :
                                    ''
                            }
                        </div>
                        <div className='subject' style={{ width: '160px' }}>SUBJECT: {letter.subject}</div>
                        <div className='subject' style={{ width: '50px' }}>refNo: {letter.refNo}</div>

                    </div>
                    <ErrorBoundary>
                        <AnnotationsEditor letterText={textLetter || letter.text} />
                    </ErrorBoundary>

                    <ErrorBoundary>
                        <AnnotationsList />
                    </ErrorBoundary>
                </div>
                <div className='sidebar' style={{ width: '47vw', height: 'calc(100vh - 100px)' }}>
                    <div className='top-bar'>
                        <ArrowBack 
                            style={{ marginTop: '7px' }}
                            fontSize='large' 
                            color='#fff'
                            hoverColor='red'
                            onClick={this.handleArrowBack}
                            
                        />
                        <h1>Vessel size {vesselSizes.length ? currentVesselSizeIndex + 1 : 0} of {vesselSizes.length}</h1>
                        <ArrowForward 
                            style={{ marginTop: '7px' }}
                            fontSize='large'     
                            color='#fff'
                            hoverColor='red'
                            onClick={this.handleArrowForward}
                        />
                    </div>

                    <ErrorBoundary>
                        {
                            vesselSizes[currentVesselSizeIndex] ?
                                <div>
                                    <SizesTable
                                        key={vesselSizes[currentVesselSizeIndex].vessel} 
                                        numberSizeTable={currentVesselSizeIndex}
                                        routeParams={{ id: vesselSizes[currentVesselSizeIndex].vessel }}
                                    />
                                    <MainInfo />
                                </div>
                                :
                                null
                        }
                    </ErrorBoundary>


                    <ul className='controller-orders' style={{ width: '47vw' }}>
                        <li>
                            <FlatButton style={styles.btnOrders} onClick={this.addSizeTable} label='Add' />
                        </li>
                        <li>
                            <FlatButton
                                style={styles.btnOrders}
                                onClick={this.removeSizeTable}
                                label='Remove' 
                            />
                        </li>
                        <li>
                            <FlatButton style={styles.btnOrders} onClick={this.clearSizeTable} label='Clear' />
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        vessel: state.vessel,
        objUser: state.user,
        user: state.vesselSizes.user,
        vesselSizes: state.vesselSizes.items,
        isLogged: state.user.isLogged,
        letter: state.letter,
        annotations: state.annotations.items,
    }),
    dispatch => bindActionCreators({
        getVesselSizes,
        updateVessel,
        postAnnotations,
        postGazetters, 
        addVesselSize,
        removeLastVesselSize,
        postRequestVessel,
        removeGazetters,
        removeAnnotations,
        removeLetter,
    }, dispatch),
)(LetterVessel);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Size/AnnotatorVesselSizePage.jsx